import {FC, useEffect, useState} from "react";
import {useSite} from "../../../../store/siteContext.ts";
import {useParams} from "react-router";
import {getIssueById, Issue} from "../../../../api/issue.ts";
import {Column} from "../../../../atoms/Layout.tsx";
import AppBarWithNavigation from "../../../../organisms/AppBarWithNavigation.tsx";
import {dashboardHome} from "../../../../helpers/paths.ts";
import FullPageLoader from "../../../../templates/FullPageLoader.tsx";
import {Text} from "../../../../style/typography.tsx";
import IssueDetails from "../../../../templates/IssueDetails.tsx";
import ContentArea from "../../../../atoms/ContentArea.tsx";

const IssueNotFound = () => <Column grow>
    <AppBarWithNavigation backTo={dashboardHome(useSite())} title="Issue Not Found"/>
    <Column grow centerVertically centerHorizontally>
        <Text role="heading" size="2" weight="medium">Issue Not Found</Text>
        <Text role="body" size="1" weight="regular">The issue you are looking for does not exist or has been deleted.</Text>
    </Column>
</Column>

const IssueDetailsPage: FC = () => {
    const site = useSite();
    const { issueId } = useParams();
    const [issue, setIssue] = useState<Issue | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (issueId) {
            getIssueById(site.id, issueId).then(setIssue).finally(() => setLoading(false));
        }
    }, [site, issueId]);

    if (!issueId) {
        return <IssueNotFound />
    }

    if (loading) {
        return <Column grow>
            <AppBarWithNavigation backTo={dashboardHome(site)}/>
            <FullPageLoader/>
        </Column>
    }

    if (!issue) {
        return <IssueNotFound />
    }

    return <Column grow>
        <AppBarWithNavigation backTo={dashboardHome(site)} title={issue.title}/>
        <ContentArea>
            <Column grow>
                <IssueDetails issue={issue} />
            </Column>
        </ContentArea>
    </Column>;
}

export default IssueDetailsPage;
